import { Injectable, inject } from '@angular/core';
import { Translation } from '../translation';
import { Store } from '@ngxs/store';
import { TranslationState, UpdateCurrentLanguageTranslationsAction } from '../../state/TranslationState';
import { translations as defaultTranslations } from '../app.translations';

export interface TranslationResponse {
  data: Array<Translation>;
  error: Array<string>;
}

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  public store = inject(Store);

  getSupportedLanguages() {
    const languages = this.store.selectSnapshot(TranslationState.allLanguageTranslations).map((t) => t.language);
    return languages.sort((a, b) => {
      if (a === 'English (US)') return -1;
      if (b === 'English (US)') return 1;
      return a.localeCompare(b);
    });
  }

  translate(key: string): string {
    const currentLanguageTranslations = this.store.selectSnapshot(TranslationState.currentLanguageTranslations);
    const allValues: string[] = ['Всички', 'All', 'Todos', 'Toutes', 'Tutto', 'Todas'];
    if (allValues.includes(key)) {
      key = 'allText';
    }

    const value = currentLanguageTranslations?.translations?.[key] ?? (defaultTranslations as Record<string, string>)[key];
    return value ?? key;
  }
  translateList(key: string[]): string[] {
    if (key != null && key.length > 0) {
      key = key.slice();
      const currentLanguageTranslations = this.store.selectSnapshot(TranslationState.currentLanguageTranslations);
      const allValues: string[] = ['Всички', 'All', 'Todos', 'Toutes', 'Tutto', 'Todas'];
      for (let i = 0; i < key.length; i++) {
        if (allValues.includes(key[i])) {
          key[i] = 'allText';
        }

        const translationValue = currentLanguageTranslations?.translations?.[key[i]];
        if (translationValue) {
          key[i] = translationValue;
          continue;
        }

        const fallbackValue = (defaultTranslations as Record<string, string>)[key[i]];
        if (fallbackValue) {
          key[i] = fallbackValue;
        }
      }
    }
    return key;
  }

  setCurrentTranslation(selectedLanguage: string) {
    this.store.dispatch(new UpdateCurrentLanguageTranslationsAction(selectedLanguage));
  }

  translateToEnglish(key: string): string {
    const allLanguageTranslations = this.store.selectSnapshot(TranslationState.allLanguageTranslations);
    const englishLanguageTranslations = allLanguageTranslations.find((value1) => value1.language === 'English (US)');
    let value: string;
    if (key) {
      const allValues: string[] = ['Всички', 'All', 'Todos', 'Toutes', 'Tutto', 'Todas'];
      if (allValues.includes(key)) {
        key = 'allText';
      }
      if (englishLanguageTranslations) {
        value = englishLanguageTranslations.translations[key];
      }

      return value ?? (defaultTranslations as Record<string, string>)[key] ?? key;
    }
    return key;
  }

  getUserpreferedLanguage(): string {
    return localStorage.getItem('language') || 'English (US)';
  }
}
